module.exports = __webpack_public_path__ + "static/media/thumbnail.6f240729.jpg";